"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPasswordErrors = exports.PasswordLoginErrors = exports.TOO_MANY_FAILED_SET_PASSWORD_ATTEMPTS = exports.TOO_MANY_FAILED_LOGIN_ATTEMPTS = void 0;
exports.TOO_MANY_FAILED_LOGIN_ATTEMPTS = 10;
exports.TOO_MANY_FAILED_SET_PASSWORD_ATTEMPTS = 30;
var PasswordLoginErrors;
(function (PasswordLoginErrors) {
    PasswordLoginErrors["SYSTEM_ACCESS_DISABLED_ERROR"] = "SYSTEM_ACCESS_DISABLED_ERROR";
    PasswordLoginErrors["ACCOUNT_LOCKED_ERROR"] = "ACCOUNT_LOCKED_ERROR";
    PasswordLoginErrors["INCORRECT_PASSWORD_ERROR"] = "INCORRECT_PASSWORD_ERROR";
})(PasswordLoginErrors || (exports.PasswordLoginErrors = PasswordLoginErrors = {}));
var SetPasswordErrors;
(function (SetPasswordErrors) {
    SetPasswordErrors["PASSCODE_RESET_TOKEN_EXPIRED"] = "PASSCODE_RESET_TOKEN_EXPIRED";
    SetPasswordErrors["INCORRECT_SSN_OR_DOB_ERROR"] = "INCORRECT_SSN_OR_DOB_ERROR";
    SetPasswordErrors["INVALID_AVEN_MY_PASSWORD"] = "INVALID_AVEN_MY_PASSWORD";
})(SetPasswordErrors || (exports.SetPasswordErrors = SetPasswordErrors = {}));
